import * as React from "react"
import {Box, Skeleton} from "@mui/material"
import { ButtonIconSeeker } from "@ui-seeker/core"
import { AppTableSeeker } from "@components"
import {translateCountryName} from "@ui-seeker/utils";

import {WEBBACK_V2_API} from "@constants";
import {useToast, useUserApp} from "@hooks";
import { usePricingMarketAnalyzerSkuDetails } from "./@hooks"
import {productSkuColumn, retailerColumn, dateColumn, priceColumn, percentageColumn, sellerColumn, buyboxColumn, stockColumn} from "./columns"
import {marketAnalyzerSkuDetailsFilters} from "../../@signals";


export default function PricingMarketAnalyzerTableSkuDetails() {
	const { showToast } = useToast()
	const { userUseRRSP } = useUserApp()
	const {
		skuName,
		country,
		isLoadingDetailsTable,
		detailsTableData,
		handleCloseDetailsSkuTable,
		isStandardUser
	} = usePricingMarketAnalyzerSkuDetails()
	
	if (isLoadingDetailsTable)
		return <Skeleton variant="rectangular" height={500} />

	if (!detailsTableData?.length)
		return <></>

	return <Box id="sku-details-table">
		<AppTableSeeker
			title={`Sku Details - ${skuName} - ${translateCountryName(country)}`}
			data={detailsTableData}
			columns={[
				dateColumn(),
				...retailerColumn(),
				...productSkuColumn(),
				priceColumn('listPrice', 'List Price'),
				priceColumn('actualPrice', 'Actual Price'),
				percentageColumn('promotion', 'Promotion'),
				...isStandardUser ? [buyboxColumn()] : [],
				...isStandardUser ? [sellerColumn()] : [],
				...stockColumn(),
				...userUseRRSP ? [priceColumn('rrsp', 'RRSP')] : [],
				...userUseRRSP ? [percentageColumn('diffVSrrsp', 'Diff Vs RRSP')] : []
			]}
			options={{
				customToolbar: () => <ButtonIconSeeker
					icon="times"
					onClick={handleCloseDetailsSkuTable}
					tooltip="Close Table"
				/>,
				onDownload: () => showToast.promiseExcel(`${WEBBACK_V2_API}/pricing/price-evolution/table-pricing-new/excel/${marketAnalyzerSkuDetailsFilters.value.sku[0]}`, {
					...marketAnalyzerSkuDetailsFilters.value,
				}, null, {
					onError: data => {
						if (data.toString().includes('Error')) return 'Excel file size exceeded'
					}
				})
			}}
		/>
	</Box>
}